import { useState } from "react";
import "./index.css";
import RoutingController from "./RoutingController";
import Loader from "./_components/Loader";


export function App() {
  return (
    <RoutingController />
  );
}

export default App;
